import { createBrowserRouter } from "react-router-dom";
import LandingPage from "./pages/LandingPage";
import LoginPage from "./pages/LoginPage";
import SignupPage from "./pages/auth/SignupPage";
import VerifyPage from "./pages/auth/VerifyPage";
import OnboardingPage from "./pages/clinic/OnboardingPage";
import DashboardPage from "./pages/clinic/DashboardPage";
import PatientsPage from "./pages/clinic/PatientsPage";
import DoctorsPage from "./pages/clinic/DoctorsPage";
import AppointmentsPage from "./pages/clinic/AppointmentsPage";
import PaymentsPage from "./pages/clinic/PaymentsPage";
import ExpensesPage from "./pages/clinic/ExpensesPage";
import ProtectedRoute from "./components/ProtectedRoute";
import Layout from "./Layout";
import { Outlet } from "react-router-dom";
import { OnboardingGuard } from "./components/OnboardingGuard";
import DashboardClientWrapper from "./components/DashboardClientWrapper";
import AppShell from "./AppShell";
import AdmittedPatientsPage from "./pages/clinic/AdmittedPatientsPage";
import PatientHistoryPage from "./pages/clinic/PatientHistoryPage";
import CalendarPage from "./pages/clinic/CalendarPage";
import BillingPage from './pages/billing/BillingPage';
import InventoryPage from "./pages/clinic/InventoryPage";
import AdminDashboardPage from './pages/admin/AdminDashboardPage';
import UsersPage from './pages/admin/UsersPage';
import SettingsPage from './pages/admin/SettingsPage';
import AdminLayout from './components/AdminLayout';
import { AuthProvider } from "./contexts/auth-context";
import UserProfilePage from "./pages/admin/UserProfilePage";

export const router = createBrowserRouter([
  {
    element: <AuthProvider><AppShell /></AuthProvider>,
    children: [
      {
        path: "/",
        element: <LandingPage />,
      },
      {
        path: "/auth/login",
        element: <LoginPage />,
      },
      {
        path: "/auth/signup",
        element: <SignupPage />,
      },
      {
        path: "/auth/verify",
        element: <VerifyPage />,
      },
      {
        path: "/admin",
        element: (
          <ProtectedRoute>
            <AdminLayout>
              <Outlet />
            </AdminLayout>
          </ProtectedRoute>
        ),
        children: [
          {
            path: "dashboard",
            element: <AdminDashboardPage />,
          },
          {
            path: "users",
            element: <UsersPage />,
          },
          {
            path: "users/:userId",
            element: <UserProfilePage />,
          },
          {
            path: "settings",
            element: <SettingsPage />,
          },
        ]
      },
      {
        path: "/app",
        element: (
          <ProtectedRoute>
            <OnboardingGuard>
              <Layout>
                <Outlet />
              </Layout>
            </OnboardingGuard>
          </ProtectedRoute>
        ),
        children: [
          {
            path: "onboarding",
            element: <OnboardingPage />,
          },
          {
            path: "dashboard",
            element: (
              <DashboardClientWrapper>
                <DashboardPage />
              </DashboardClientWrapper>
            ),
          },
          {
            path: "patients",
            element: <PatientsPage />,
          },
          {
            path: "doctors",
            element: <DoctorsPage />,
          },
          {
            path: "appointments",
            element: <AppointmentsPage />,
          },
          {
            path: "calendar",
            element: <CalendarPage />,
          },
          {
            path: "payments",
            element: <PaymentsPage />,
          },
          {
            path: "daily-expense",
            element: <ExpensesPage />,
          },
          {
            path: "admitted-patients",
            element: <AdmittedPatientsPage />,
          },
          {
            path: "patient-history",
            element: <PatientHistoryPage />,
          },
          {
            path: "billing",
            element: <BillingPage />,
          },
          {
            path: "inventory",
            element: <InventoryPage />,
          },
        ],
      },
    ],
  },
]); 